module.exports = __webpack_public_path__ + "static/media/undraw_celebration.cc4e81d5.svg";